import type { ButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import * as React from 'react';
import { LuArrowLeft, LuCheck, LuLogOut, LuMessageCircle, LuPencil, LuPlus, LuRepeat, LuX } from 'react-icons/lu';

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function CloseButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>
      {props.children ?? <LuX />}
    </ChakraIconButton>
  );
});

export const EditButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Edit" ref={ref} {...props}>
      {props.children ?? <LuPencil />}
    </ChakraIconButton>
  );
});
export const AddButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Add" ref={ref} {...props}>
      {props.children ?? <LuPlus />}
    </ChakraIconButton>
  );
});
export const LogOutButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Logout" ref={ref} {...props}>
      {props.children ?? <LuLogOut />}
    </ChakraIconButton>
  );
});

export const CheckButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Confirm" ref={ref} {...props}>
      {props.children ?? <LuCheck />}
    </ChakraIconButton>
  );
});

export const ChatButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Confirm" ref={ref} {...props}>
      {props.children ?? <LuMessageCircle />}
    </ChakraIconButton>
  );
});
export const BackButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Confirm" ref={ref} {...props}>
      {props.children ?? <LuArrowLeft />}
    </ChakraIconButton>
  );
});
export const UpdateButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Confirm" ref={ref} {...props}>
      {props.children ?? <LuRepeat />}
    </ChakraIconButton>
  );
});

export const IconButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function EditButton(props, ref) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Confirm" ref={ref} {...props}>
      {props.children}
    </ChakraIconButton>
  );
});
